import angular from 'angular';
import { MeurhTransferenciaColaboradoresService } from './transferenciacolaboradores.service';
import { ListagemService } from '../../../shared/services/listagem.service';

export const MeurhTransferenciaColaboradoresListRouting = ['$stateProvider', function ($stateProvider: angular.ui.IStateProvider) {
    const resolve = {
        'entity': [
            'MeurhTransferenciaColaboradoresService',
            'ListagemService',
            '$rootScope',
            '$stateParams',
            '$state',
            '$q',
            function (
                entityService: MeurhTransferenciaColaboradoresService,
                listagemService: ListagemService,
                $rootScope: angular.IRootScopeService & {
                    session: any,
                    liberadoTela: (arg: string) => boolean
                },
                $stateParams: angular.ui.IStateParamsService,
                $state: angular.ui.IStateService,
                $q: angular.IQService
            ) {
                if (!$stateParams['solicitacao']) {
                    return $q<void>(() => $state.go('meurh_solicitacoestransferenciasvagas'));
                }

                return entityService.get($stateParams['solicitacao'])
                    .then((data) => {
                        const visibilidadeLiberada = $rootScope.liberadoTela('LIBERAR_REFATORACAO_VISIBILIDADE');
                        const empresaNoGrupo = listagemService.getEmpresa(data.empresaobj.empresa);
                        const mesmoEstabelecimento = data.estabelecimentoobj.estabelecimento === $rootScope.session.entities.estabelecimento.estabelecimento;

                        const deveRedirecionar = (
                            (visibilidadeLiberada && !empresaNoGrupo) ||
                            (!visibilidadeLiberada && !mesmoEstabelecimento)
                        );

                        if (deveRedirecionar) {
                            return $q(() => $state.go('meurh_solicitacoestransferenciasvagas'));
                        }

                        return data;
                    })
                    .catch((error) => {
                        if (error.status === 404) {
                            return $q(() => {
                                if ($state.href('meurh_solicitacoestransferenciasvagas_not_found', $stateParams)) {
                                    $state.go('meurh_solicitacoestransferenciasvagas_not_found', $stateParams);
                                } else {
                                    $state.go('not_found', $stateParams);
                                }
                            });
                        }

                        return $q.reject(error);
                    });
            }
        ]
    };

    $stateProvider
        .state('meurh_solicitacoestransferenciasvagas', {
            url: '/transferenciacolaboradores?q',
            template: require('html-loader!./index/transferenciacolaboradores.index.html'),
            controller: 'Meurh\TransferenciaColaboradoresIndexController',
            controllerAs: 'mrh_trnsfrncclbrdrs_lst_cntrllr',
            reloadOnSearch: false
        })
        .state('meurh_solicitacoestransferenciasvagas_new', {
            parent: 'meurh_solicitacoestransferenciasvagas',
            url: '/new',
            params: {
                tipo: 'individual',
            },
            template: require('html-loader!./new/transferenciacolaboradores.new.html'),
            controller: 'MeurhTransferenciaColaboradoresNewController',
            controllerAs: 'mrh_trnsfrncclbrdrs_frm_nw_cntrllr'
        })
        .state('meurh_solicitacoestransferenciasvagas_show', {
            parent: 'meurh_solicitacoestransferenciasvagas',
            url: '/show/:solicitacao?path',
            resolve,
            template: require('html-loader!./show/transferenciacolaboradores.show.html'),
            controller: 'MeurhTransferenciaColaboradoresShowController',
            controllerAs: 'mrh_trnsfrncclbrdrs_frm_shw_cntrllr'
        })
        .state('meurh_solicitacoestransferenciasvagas_edit', {
            parent: 'meurh_solicitacoestransferenciasvagas',
            url: '/edit/:solicitacao?path',
            resolve,
            template: require('html-loader!./edit/transferenciacolaboradores.edit.html'),
            controller: 'MeurhTransferenciaColaboradoresEditController',
            controllerAs: 'mrh_trnsfrncclbrdrs_frm_edt_cntrllr'
        });
    }
];
